import { ESpineRenderType } from "../SpineSkeleton";
import { AnimationRender } from "./AnimationRender";
import { AttachmentParse } from "./AttachmentParse";
import { IBCreator } from "./IBCreator";
import { SlotUtils } from "./SlotUtils";
import { SpineNormalRender } from "./SpineNormalRender";
import { SpineOptimizeRender } from "./SpineOptimizeRender";
import { VBBoneCreator, VBRigBodyCreator } from "./VBCreator";
export class SketonOptimise {
    constructor() {
        this.blendModeMap = new Map();
        this.skinAttachArray = [];
        this.animators = [];
        this.canCache = SketonOptimise.cacheSwitch;
    }
    _initSpineRender(skeleton, templet, renderNode, state) {
        let sp;
        if (SketonOptimise.normalRenderSwitch) {
            sp = new SpineNormalRender();
        }
        else if (this.maxBoneNumber > SketonOptimise.MAX_BONES) {
            console.warn("The number of Bones :", this.maxBoneNumber, " > ", SketonOptimise.MAX_BONES, ", use CPU caculation");
            sp = new SpineNormalRender();
        }
        else {
            sp = new SpineOptimizeRender(this);
        }
        sp.init(skeleton, templet, renderNode, state);
        return sp;
    }
    _updateState(delta) {
        this._state.update(delta);
        let trackEntry = this._state.getCurrent(0);
        this._state.apply(this.sketon);
        this.sketon.updateWorldTransform(2);
        return this.sketon.bones;
    }
    _play(animationName) {
        let trackEntry = this._state.setAnimation(0, animationName, true);
        trackEntry.animationStart = 0;
        let animationDuration = trackEntry.animation.duration;
        return animationDuration;
    }
    checkMainAttach(skeletonData) {
        this.sketon = new spine.Skeleton(skeletonData);
        this._stateData = new spine.AnimationStateData(this.sketon.data);
        this._state = new spine.AnimationState(this._stateData);
        this.attachMentParse(skeletonData);
        this.initAnimation(skeletonData.animations);
    }
    attachMentParse(skeletonData) {
        let skins = skeletonData.skins;
        let slots = skeletonData.slots;
        let defaultSkinAttach;
        this._tempIbCreate = new IBCreator();
        for (let i = 0, n = skins.length; i < n; i++) {
            let skin = skins[i];
            let skinAttach = new SkinAttach();
            skinAttach.name = skin.name;
            skinAttach._tempIbCreate = this._tempIbCreate;
            if (i != 0) {
                skinAttach.copyFrom(defaultSkinAttach);
            }
            skinAttach.attachMentParse(skin, slots);
            this.skinAttachArray.push(skinAttach);
            skinAttach.init(slots);
            if (i == 0) {
                defaultSkinAttach = skinAttach;
            }
        }
    }
    initAnimation(animations) {
        let maxBoneNumber = 0;
        for (let i = 0, n = animations.length; i < n; i++) {
            let animation = animations[i];
            let animator = new AnimationRender();
            animator.check(animation, this);
            this.animators.push(animator);
            this.skinAttachArray.forEach((value) => {
                value.initAnimator(animator);
            });
            animator.skinDataArray.forEach((skinData) => {
                if (!skinData.isNormalRender) {
                    let boneNumber = skinData.vb.boneArray.length / 2;
                    if (boneNumber > maxBoneNumber) {
                        maxBoneNumber = boneNumber;
                    }
                }
            });
        }
        this.maxBoneNumber = maxBoneNumber;
    }
    cacheBone() {
        if (!SketonOptimise.cacheSwitch) {
            for (let i = 0, n = this.animators.length; i < n; i++) {
                let animator = this.animators[i];
                if (animator.boneFrames.length == 0) {
                    animator.cacheBones(this);
                }
            }
        }
    }
    destroy() {
        for (let i = 0, n = this.animators.length; i < n; i++)
            this.animators[i].destroy();
        this.animators.length = 0;
    }
    init(slots) {
    }
}
SketonOptimise.normalRenderSwitch = false;
SketonOptimise.MAX_BONES = 100;
SketonOptimise.cacheSwitch = false;
export class SkinAttach {
    constructor() {
        this.vertexBones = 0;
        this.slotAttachMap = new Map();
        this.mainAttachMentOrder = [];
    }
    copyFrom(other) {
        other.slotAttachMap.forEach((value, key) => {
            this.slotAttachMap.set(key, new Map(value));
        });
    }
    attachMentParse(skinData, slots) {
        let type = ESpineRenderType.rigidBody;
        let vertexBones = 0;
        let attachments = skinData.attachments;
        let vertexCount = 0;
        let indexCount = 0;
        let twoColorTint = false;
        for (let i = 0, n = slots.length; i < n; i++) {
            let attachment = attachments[i];
            let slot = slots[i];
            let boneIndex = slot.boneData.index;
            let map = this.slotAttachMap.get(i);
            let slotAttachName = slot.attachmentName;
            if (!map) {
                map = new Map();
                this.slotAttachMap.set(i, map);
            }
            if (attachment) {
                for (let key in attachment) {
                    let attach = attachment[key];
                    let deform = null;
                    let parse = new AttachmentParse();
                    parse.init(attach, boneIndex, i, deform, slot);
                    vertexBones = Math.max(vertexBones, parse.vertexBones);
                    let tempType = SlotUtils.checkAttachment(parse ? parse.sourceData : null);
                    if (tempType < type) {
                        type = tempType;
                    }
                    indexCount += parse.indexCount;
                    vertexCount += parse.vertexCount;
                    twoColorTint = twoColorTint || !!parse.darkColor;
                    map.set(key, parse);
                }
            }
            else if (slotAttachName) {
                let parse = map.get(slotAttachName);
                if (parse) {
                    indexCount += parse.indexCount;
                    vertexCount += parse.vertexCount;
                    vertexBones = Math.max(vertexBones, parse.vertexBones);
                    let tempType = SlotUtils.checkAttachment(parse ? parse.sourceData : null);
                    if (tempType < type) {
                        type = tempType;
                    }
                    twoColorTint = twoColorTint || !!parse.darkColor;
                }
            }
            if (!map.get(null)) {
                let nullAttachment = new AttachmentParse();
                nullAttachment.slotId = i;
                nullAttachment.color = slot.color;
                nullAttachment.boneIndex = boneIndex;
                nullAttachment.attachment = null;
                map.set(nullAttachment.attachment, nullAttachment);
            }
        }
        this.type = type;
        this.vertexBones = vertexBones;
        let flag;
        switch (this.type) {
            case ESpineRenderType.normal:
                flag = "UV,COLOR,POSITION,BONE";
                if (twoColorTint)
                    flag += ",COLOR2";
                this.mainVB = new VBBoneCreator(flag, vertexCount);
                break;
            case ESpineRenderType.boneGPU:
                flag = "UV,COLOR,POSITION,BONE";
                if (twoColorTint)
                    flag += ",COLOR2";
                this.mainVB = new VBBoneCreator(flag, vertexCount);
                break;
            case ESpineRenderType.rigidBody:
                flag = "UV,COLOR,POSITION,RIGIDBODY";
                if (twoColorTint)
                    flag += ",COLOR2";
                this.mainVB = new VBRigBodyCreator(flag, vertexCount);
                break;
        }
        this.mainIB = new IBCreator();
        this.mainIB.updateFormat(vertexCount);
        this.mainIB.setBufferLength(indexCount);
    }
    init(slots) {
        let mainAttachMentOrder = this.mainAttachMentOrder;
        slots.forEach((slot, index) => {
            let attchment = slot.attachmentName;
            if (attchment) {
                let attach = this.slotAttachMap.get(index).get(attchment);
                if (attach) {
                    this.mainVB.appendVB(attach);
                }
                else {
                    attach = this.slotAttachMap.get(index).get(null);
                }
                if (attach.isClip)
                    this.isNormalRender = true;
                mainAttachMentOrder.push(attach);
            }
            else {
                let attach = this.slotAttachMap.get(index).get(null);
                mainAttachMentOrder.push(attach);
            }
        });
        this.mainVB.initBoneMat();
        this.mainIB.createIB(mainAttachMentOrder, this.mainVB);
    }
    initAnimator(animator) {
        let skinData = animator.createSkinData(this.mainVB, this.mainIB, this._tempIbCreate, this.slotAttachMap, this.mainAttachMentOrder, this.type);
        skinData.name = this.name;
        if (this.isNormalRender) {
            skinData.isNormalRender = true;
        }
        if (skinData.isNormalRender) {
            this.hasNormalRender = true;
        }
    }
}
